<template>
    <div style="line-height: 60px; display: flex">
      <div style="flex: 1; font-size: 18px">
        <span :class="CollapseBtnClass" style="cursor: pointer" @click="collapse"></span>
        <el-breadcrumb separator-class="el-icon-arrow-right" style="display: inline-block; margin-left: 10px">
          <el-breadcrumb-item :to="{path: 'home'}">首页</el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item, index) in $route.meta" :key="index">
            {{ item }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="width: 50px">
  
      </div>
      <el-dropdown style="width: 100px; cursor: pointer">
        <div>
          <el-avatar style="top: 10px;margin-right: 10px; position: relative">User</el-avatar><!--            <i class="el-icon-setting" style="margin-right: 15px"></i>-->
          <span>{{ User.name || '用户' }}</span>
        </div>
        <!--            <i class="el-icon-arrow-down" style="margin-left: 5px"></i>-->
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item >
            <span @click="$router.push('/person')">个人信息</span>
          </el-dropdown-item>
          <el-dropdown-item style="text-align:center">
            <span @click="logout">退出</span>
          </el-dropdown-item>
  
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </template>
  
  <script>
  export default {
    name: "Header",
    data () {
      return{
        User: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")): {}
      }
    },
    props: {
      CollapseBtnClass: String,
      collapse: Function,
    },
    methods: {
      logout () {
        // 清除用户信息
        localStorage.removeItem("user")
        this.$message.success("退出成功")
        // 跳转到登录页面
        this.$router.push("/backstagelogin")
      },
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  